var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeHoverLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8999 0.765639C21.7954 0.796519 22.4902 1.18251 22.9842 1.92362C23.5092 2.66473 23.818 3.48304 23.9106 4.37855C24.1268 7.31211 24.1268 10.2302 23.9106 13.1329C23.818 13.9667 23.4937 14.785 22.9379 15.5878C22.3821 16.3907 21.7027 16.8693 20.8999 17.0237C15.5886 17.4252 9.81408 17.4252 3.57641 17.0237C2.77354 16.9002 2.09419 16.437 1.53836 15.6342C0.982523 14.8313 0.658287 13.9975 0.565649 13.1329C0.349492 10.292 0.349492 7.45107 0.565649 4.61015C0.658287 3.74552 0.982523 2.91177 1.53836 2.1089C2.09419 1.30603 2.77354 0.858278 3.57641 0.765639C8.70242 0.333325 14.4769 0.333325 20.8999 0.765639ZM9.27369 13.0866L16.6848 8.82521L9.27369 4.56383V13.0866Z",
    fill: "#3C9C75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeHoverLogo);
export default __webpack_public_path__ + "static/media/YoutubeHoverLogo.9387cf2aac9c107b74a672ae739d9d92.svg";
export { ForwardRef as ReactComponent };